import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var LimitChars = styled.div.withConfig({
  displayName: "LimitChars",
  componentId: "sc-13xqzqg-0"
})(["position:absolute;bottom:0;right:0;width:40px;height:40px;border-radius:40px;box-shadow:", ";cursor:pointer;background-color:", ";", ";font-weight:500;line-height:40px;letter-spacing:-1px;color:", ";text-align:center;transform:translateX( ", "px );", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.boxShadow;
}, function (_ref2) {
  var theme = _ref2.theme,
    isLimit = _ref2.isLimit;
  return isLimit ? theme.colors.negative : '#fff';
}, getFont(0), function (_ref3) {
  var theme = _ref3.theme,
    isLimit = _ref3.isLimit;
  return isLimit ? '#fff' : theme.mainColor;
}, function (_ref4) {
  var extraPadding = _ref4.extraPadding;
  return extraPadding ? 46 + extraPadding : 46;
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));